import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { GoogleButton } from "@/components/GoogleButton";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back to the console");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-ink">Sign in</h1>
      <p className="mt-2 text-sm text-muted">Access your security console and AI engineers.</p>

      <div className="mt-8"><GoogleButton /></div>

      <div className="my-6 flex items-center gap-4">
        <div className="h-px flex-1 bg-line" />
        <span className="text-xs text-muted font-mono">OR</span>
        <div className="h-px flex-1 bg-line" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email" className="text-ink">Work email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email" placeholder="you@company.com"
            className="mt-1.5 bg-[var(--surface-2)] border-line text-ink" />
        </div>
        <div>
          <Label htmlFor="password" className="text-ink">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password" placeholder="••••••••"
            className="mt-1.5 bg-[var(--surface-2)] border-line text-ink" />
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full bg-cyber text-[#0B0E14] hover:bg-cyber-dim font-semibold h-11">
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Sign in to Console"}
        </Button>
      </form>

      <p className="mt-6 text-sm text-muted text-center">
        No account?{" "}
        <Link to="/signup" className="text-cyber font-semibold hover:underline" data-testid="link-signup">
          Start free
        </Link>
      </p>
    </AuthShell>
  );
}
